/**
 * Common screen sizes
 */
const screens = {
    s: 360,
    m: 830,
    l: 960,
    xl: 1200,
};

/**
 * Global package config for TS and SCSS
 */
export default {
    debug: process.env.NODE_ENV !== 'production',

    mediaQueries: {
        mouse: '(pointer: fine)',

        s: `(min-width:${screens.s}px)`,
        m: `(min-width:${screens.m}px)`,
        l: `(min-width:${screens.l}px)`,
        xl: `(min-width:${screens.xl}px)`,

        // We don't use these for now
        // toS: `(max-width:${screens.s - 1}px)`,
        // toM: `(max-width:${screens.m - 1}px)`,
        // toL: `(max-width:${screens.l - 1}px)`,
        // toXl: `(max-width:${screens.xl - 1}px)`,
    },
}
